import Skeleton from 'react-loading-skeleton'
import type { FragmentType } from '~/lib/graphql'
import type { ReviewsNodesFragment } from '../../reviewsNode.frag'
import { ReviewComponent } from './Review'

type Props = {
  reviews?: FragmentType<typeof ReviewsNodesFragment>[]
  isPc: boolean
}

const ReviewList: React.FC<Props> = ({ reviews, isPc }) => {
  return (
    <>
      {typeof reviews === 'undefined' ? (
        <Skeleton width="100%" height={50} />
      ) : (
        <>
          {reviews.map((review, index) => {
            return <ReviewComponent key={index} review={review} isPc={isPc} />
          })}
        </>
      )}
    </>
  )
}

export default ReviewList
